import { Component, OnInit } from '@angular/core';
import { AutoUnsubscribe } from 'ngx-auto-unsubscribe';
import { ActivatedRoute, Router } from '@angular/router';
import * as moment from 'moment';
import * as _ from 'lodash';
import { saveAs } from 'file-saver';
import { QualityService } from 'app/shared/services/quality.service';
import { DictionaryService } from 'app/shared/services/dictionary.service';
import { HttpService } from 'app/shared/services/http.service';
import { GridService } from 'app/shared/services/grid.service';
import { SharedService } from 'app/shared/services/shared.service';
import { GoogleAnalyticsService } from 'app/shared/services/google-analytics.service';

@AutoUnsubscribe()
@Component({
  selector: 'app-quality-by-demand',
  templateUrl: './quality-by-demand.component.html',
  styleUrls: ['./quality-by-demand.component.scss'],
})
export class QualityByDemandComponent implements OnInit {
  public queryParams: any;
  public data: Array<any>;
  public dataTotal: any;
  public dataByDemandBySupply: any;
  public dataByDemandBySupplyTotal: any;
  public dataByDemandByDomain: any;
  public dataByDemandByDomainTotal: any;
  public columnsSupplyMoat: Array<any>;
  public columnsDomainMoat: Array<any>;
  public columnsSettings: Array<any>;
  public currPluginPartner: number;
  public demandId: any;
  public demands: Array<any>;
  public isLoading: boolean;
  public isError: boolean;
  public isExporting: boolean;
  public startDate: Date;
  public selectedTab: number;
  public endDate: Date;
  public reportParams: any;
  public loadedReports: Array<any>;
  public currPage: number;
  public filters: any;
  public sorting: any;
  public itemsPerPage: number;
  public numOfPages: number;
  public totalAmount: number;
  public linkColumns: Array<string>;
  public currSubscription: any;
  public currTotalsSubscription: any;
  public subscriptions: Array<any>;

  constructor(
    public router: Router,
    public route: ActivatedRoute,
    public sharedService: SharedService,
    public httpService: HttpService,
    public gridService: GridService,
    public qualityService: QualityService,
    public dictionaryService: DictionaryService,
    public ga: GoogleAnalyticsService
  ) {
    this.data = [];
    this.dataTotal = {};
    this.dataByDemandBySupply = [];
    this.dataByDemandBySupplyTotal = [];
    this.dataByDemandByDomain = [];
    this.dataByDemandByDomainTotal = [];
    this.demands = [];
    this.isLoading = false;
    this.isError = false;
    this.isExporting = false;
    this.currPage = 1;
    this.filters = {};
    this.sorting = {};
    this.itemsPerPage = 50;
    this.totalAmount = 0;
    this.numOfPages = 0;
    this.linkColumns = [];
    this.columnsSettings = [];
    this.columnsSupplyMoat = [
      { key: 'playerId', label: 'SUPPLY_ID', filterType: 'INPUT', primaryKey: true },
      { key: 'name', label: 'SUPPLY_NAME', filterType: 'INPUT', width: 200 },
      {
        key: 'adStarts',
        label: 'IMPRESSIONS',
        tooltipKey: 'REPORT_TOOLTIP_I',
        parseFunction: this.gridService.parseNumeric,
        parseTooltipFunction: this.gridService.parseNumeric,
      },
      {
        key: 'revenue',
        label: 'REVENUE',
        parseFunction: this.gridService.parseNumericPadd,
        parseTooltipFunction: this.gridService.parseNumericPadd,
        measureFilter: true,
        filterType: 'RANGE',
        char: '$',
        align: 'left',
        defaultVisibility: false,
      },
      {
        key: 'total',
        tooltipKey: 'SAMPLED_IMPRESSIONS_TT',
        label: 'SAMPLED_IMPRESSIONS',
        rightAligned: true,
        parseFunction: this.gridService.parseNumeric,
        parseTooltipFunction: this.gridService.parseNumeric,
      },
      {
        key: 'ivt_measurable',
        tooltipKey: 'IVT_MEASURABLE',
        label: 'IVT_MEASURABLE',
        rightAligned: true,
        parseFunction: this.gridService.parseNumeric,
        parseTooltipFunction: this.gridService.parseNumeric,
        measureFilter: false,
      },
      {
        key: 'ivt_measurable_rate',
        tooltipKey: 'IVT_MEASURABLE_PERCENTAGE_TT',
        label: 'IVT_MEASURABLE_PERCENTAGE',
        rightAligned: true,
        parseFunction: this.gridService.parseNumericPadd,
        parseTooltipFunction: this.gridService.parseNumericPadd,
        measurement: { char: '%', align: 'right' },
        defaultVisibility: false,
        measureFilter: false,
      },
      {
        key: 'ivt',
        tooltipKey: 'IVT_MEASURABLE_PERCENTAGE_TT',
        label: 'IVT',
        rightAligned: true,
        parseFunction: this.gridService.parseNumeric,
        parseTooltipFunction: this.gridService.parseNumeric,
        measureFilter: false,
      },
      {
        key: 'ivt_rate',
        tooltipKey: 'IVT_PERCENTAGE_TT',
        label: 'IVT_PERCENTAGE',
        rightAligned: true,
        parseFunction: this.gridService.parseNumericPadd,
        parseTooltipFunction: this.gridService.parseNumericPadd,
        measurement: { char: '%', align: 'right' },
        measureFilter: false,
      },
      {
        key: 'data_center_traffic',
        label: 'DATA_CENTER_TRAFFIC',
        tooltipKey: 'DATA_CENTER_TRAFFIC',
        rightAligned: true,
        parseFunction: this.gridService.parseNumeric,
        parseTooltipFunction: this.gridService.parseNumeric,
        measureFilter: false,
        defaultVisibility: false,
      },
      {
        key: 'old_browser',
        label: 'OLD_BROWSER',
        tooltipKey: 'OLD_BROWSER',
        rightAligned: true,
        parseFunction: this.gridService.parseNumeric,
        parseTooltipFunction: this.gridService.parseNumeric,
        measureFilter: false,
        defaultVisibility: false,
      },
      {
        key: 'proxy_traffic',
        label: 'PROXY_TRAFFIC',
        tooltipKey: 'PROXY_TRAFFIC',
        rightAligned: true,
        parseFunction: this.gridService.parseNumeric,
        parseTooltipFunction: this.gridService.parseNumeric,
        measureFilter: false,
        defaultVisibility: false,
      },
      {
        key: 'viewability_analyzed',
        label: 'VIEWABILITY_ANALYZED',
        tooltipKey: 'VIEWABILITY_ANALYZED',
        rightAligned: true,
        parseFunction: this.gridService.parseNumeric,
        parseTooltipFunction: this.gridService.parseNumeric,
        measureFilter: false,
      },
      {
        key: 'viewability_measurable',
        tooltipKey: 'VIEWABILITY_MEASURABLE',
        label: 'VIEWABILITY_MEASURABLE',
        rightAligned: true,
        parseFunction: this.gridService.parseNumeric,
        parseTooltipFunction: this.gridService.parseNumeric,
        measureFilter: false,
      },
      {
        key: 'viewability_measurable_rate',
        tooltipKey: 'VIEWABILITY_MEASURABLE_PERCENTAGE',
        label: 'VIEWABILITY_MEASURABLE_PERCENTAGE',
        rightAligned: true,
        parseFunction: this.gridService.parseNumericPadd,
        parseTooltipFunction: this.gridService.parseNumericPadd,
        measurement: { char: '%', align: 'right' },
        defaultVisibility: false,
        measureFilter: false,
      },
      {
        key: 'viewability',
        tooltipKey: 'VIEWABILITY',
        label: 'VIEWABILITY',
        rightAligned: true,
        parseFunction: this.gridService.parseNumeric,
        parseTooltipFunction: this.gridService.parseNumeric,
        measureFilter: false,
      },
      {
        key: 'viewability_rate',
        label: 'VIEWABILITY_PERCENTAGE',
        rightAligned: true,
        parseFunction: this.gridService.parseNumericPadd,
        parseTooltipFunction: this.gridService.parseNumericPadd,
        measurement: { char: '%', align: 'right' },
        measureFilter: false,
      },
      {
        key: 'hover',
        tooltipKey: 'HOVERS',
        label: 'HOVERS',
        rightAligned: true,
        parseFunction: this.gridService.parseNumeric,
        parseTooltipFunction: this.gridService.parseNumeric,
        measureFilter: false,
        defaultVisibility: false,
      },
      {
        key: 'hover_percent',
        tooltipKey: 'HOVERS_PERCENT_TT',
        label: 'HOVERS_PERCENTAGE',
        rightAligned: true,
        parseFunction: this.gridService.parseNumericPadd,
        parseTooltipFunction: this.gridService.parseNumericPadd,
        measurement: { char: '%', align: 'right' },
        defaultVisibility: false,
        measureFilter: false,
      },
    ];
    this.columnsDomainMoat = [
      { key: 'domain', label: 'DOMAIN', filterType: 'INPUT', primaryKey: true },
      {
        key: 'adStarts',
        label: 'IMPRESSIONS',
        tooltipKey: 'REPORT_TOOLTIP_I',
        parseFunction: this.gridService.parseNumeric,
        parseTooltipFunction: this.gridService.parseNumeric,
      },
      {
        key: 'revenue',
        label: 'REVENUE',
        parseFunction: this.gridService.parseNumericPadd,
        parseTooltipFunction: this.gridService.parseNumericPadd,
        measureFilter: true,
        filterType: 'RANGE',
        char: '$',
        align: 'left',
        defaultVisibility: false,
      },
      {
        key: 'total',
        tooltipKey: 'SAMPLED_IMPRESSIONS_TT',
        label: 'SAMPLED_IMPRESSIONS',
        rightAligned: true,
        parseFunction: this.gridService.parseNumeric,
        parseTooltipFunction: this.gridService.parseNumeric,
      },
      {
        key: 'ivt_measurable',
        tooltipKey: 'IVT_MEASURABLE',
        label: 'IVT_MEASURABLE',
        rightAligned: true,
        parseFunction: this.gridService.parseNumeric,
        parseTooltipFunction: this.gridService.parseNumeric,
        measureFilter: false,
      },
      {
        key: 'ivt_measurable_rate',
        tooltipKey: 'IVT_MEASURABLE_PERCENTAGE_TT',
        label: 'IVT_MEASURABLE_PERCENTAGE',
        rightAligned: true,
        parseFunction: this.gridService.parseNumericPadd,
        parseTooltipFunction: this.gridService.parseNumericPadd,
        measurement: { char: '%', align: 'right' },
        measureFilter: false,
        defaultVisibility: false,
      },
      {
        key: 'ivt',
        tooltipKey: 'IVT_MEASURABLE_PERCENTAGE_TT',
        label: 'IVT',
        rightAligned: true,
        parseFunction: this.gridService.parseNumeric,
        parseTooltipFunction: this.gridService.parseNumeric,
        measureFilter: false,
      },
      {
        key: 'ivt_rate',
        tooltipKey: 'IVT_PERCENTAGE_TT',
        label: 'IVT_PERCENTAGE',
        rightAligned: true,
        parseFunction: this.gridService.parseNumericPadd,
        parseTooltipFunction: this.gridService.parseNumericPadd,
        measurement: { char: '%', align: 'right' },
        measureFilter: false,
      },
      {
        key: 'data_center_traffic',
        label: 'DATA_CENTER_TRAFFIC',
        tooltipKey: 'DATA_CENTER_TRAFFIC',
        rightAligned: true,
        parseFunction: this.gridService.parseNumeric,
        parseTooltipFunction: this.gridService.parseNumeric,
        measureFilter: false,
        defaultVisibility: false,
      },
      {
        key: 'old_browser',
        label: 'OLD_BROWSER',
        tooltipKey: 'OLD_BROWSER',
        rightAligned: true,
        parseFunction: this.gridService.parseNumeric,
        parseTooltipFunction: this.gridService.parseNumeric,
        measureFilter: false,
        defaultVisibility: false,
      },
      {
        key: 'proxy_traffic',
        label: 'PROXY_TRAFFIC',
        tooltipKey: 'PROXY_TRAFFIC',
        rightAligned: true,
        parseFunction: this.gridService.parseNumeric,
        parseTooltipFunction: this.gridService.parseNumeric,
        measureFilter: false,
        defaultVisibility: false,
      },
      {
        key: 'viewability_analyzed',
        label: 'VIEWABILITY_ANALYZED',
        tooltipKey: 'VIEWABILITY_ANALYZED',
        rightAligned: true,
        parseFunction: this.gridService.parseNumeric,
        parseTooltipFunction: this.gridService.parseNumeric,
        measureFilter: false,
      },
      {
        key: 'viewability_measurable',
        tooltipKey: 'VIEWABILITY_MEASURABLE',
        label: 'VIEWABILITY_MEASURABLE',
        rightAligned: true,
        parseFunction: this.gridService.parseNumeric,
        parseTooltipFunction: this.gridService.parseNumeric,
        visible: true,
        measureFilter: false,
      },
      {
        key: 'viewability_measurable_rate',
        tooltipKey: 'VIEWABILITY_MEASURABLE_PERCENTAGE',
        label: 'VIEWABILITY_MEASURABLE_PERCENTAGE',
        rightAligned: true,
        parseFunction: this.gridService.parseNumericPadd,
        parseTooltipFunction: this.gridService.parseNumericPadd,
        measurement: { char: '%', align: 'right' },
        defaultVisibility: false,
        measureFilter: false,
      },
      {
        key: 'viewability',
        tooltipKey: 'VIEWABILITY',
        label: 'VIEWABILITY',
        rightAligned: true,
        parseFunction: this.gridService.parseNumeric,
        parseTooltipFunction: this.gridService.parseNumeric,
        measureFilter: false,
      },
      {
        key: 'viewability_rate',
        label: 'VIEWABILITY_PERCENTAGE',
        rightAligned: true,
        parseFunction: this.gridService.parseNumericPadd,
        parseTooltipFunction: this.gridService.parseNumericPadd,
        measurement: { char: '%', align: 'right' },
        measureFilter: false,
      },
      {
        key: 'hover',
        tooltipKey: 'HOVERS',
        label: 'HOVERS',
        rightAligned: true,
        parseFunction: this.gridService.parseNumeric,
        parseTooltipFunction: this.gridService.parseNumeric,
        measureFilter: false,
        defaultVisibility: false,
      },
      {
        key: 'hover_percent',
        tooltipKey: 'HOVERS_PERCENT_TT',
        label: 'HOVERS_PERCENTAGE',
        rightAligned: true,
        parseFunction: this.gridService.parseNumericPadd,
        parseTooltipFunction: this.gridService.parseNumericPadd,
        measurement: { char: '%', align: 'right' },
        defaultVisibility: false,
        measureFilter: false,
      },
    ];
    this.initLoadedReportsData();
    this.subscriptions = [];
    this.subscriptions.push(
      this.route.queryParams.subscribe(
        (queryParams: any) => {
          // Store the query params
          this.queryParams = _.cloneDeep(queryParams);
          // Demand ID
          this.demandId = location.pathname.split(/[\s/]+/).pop();

          // Start and end date
          const dates: any = {};
          let startDateStr = '';
          let endDateStr = '';
          if (this.queryParams.sd && this.queryParams.ed) {
            startDateStr = this.queryParams.sd;
            endDateStr = this.queryParams.ed;
          } else if (!this.sharedService.isEmpty(localStorage.getItem('selectedDates'))) {
            const savedDates: any = JSON.parse(localStorage.getItem('selectedDates'));
            startDateStr = savedDates.startDate;
            endDateStr = savedDates.endDate;
          }

          this.startDate = this.sharedService.stringToESTDate(startDateStr);
          this.endDate = this.sharedService.stringToESTDate(endDateStr);
          dates.startDate = this.startDate;
          dates.endDate = this.endDate;
          localStorage.setItem('selectedDates', JSON.stringify(dates));

          // Plugin partner
          this.currPluginPartner = this.qualityService.pluginPartners[0].id;
          if (this.queryParams.partner) {
            if (!isNaN(Number(this.queryParams.partner))) {
              this.currPluginPartner = +this.queryParams.partner;
              if (!_.map(this.qualityService.pluginPartners, 'id').includes(this.currPluginPartner)) {
                this.currPluginPartner = this.qualityService.pluginPartners[0].id;
              }
            }
          }
          // Selected tab
          this.selectedTab = 0;
          if (this.queryParams.tab) {
            if (!isNaN(Number(this.queryParams.tab))) {
              this.selectedTab = +this.queryParams.tab;
              if (this.currPluginPartner === 4) {
                if (this.selectedTab !== 0 && this.selectedTab !== 1) {
                  this.selectedTab = 0;
                }
              }
            }
          }
          // Page
          if (this.queryParams.p) {
            this.currPage = !this.sharedService.isEmpty(this.queryParams.p) ? +this.queryParams.p : 1;
          } else {
            this.currPage = 1;
          }
          // Get report
          this.getQualityByDemandReport(this.demandId);
        },
        () => {
          this.isLoading = false;
          this.isError = true;
        }
      )
    );
  }

  ngOnDestroy() {}

  ngOnInit() {
    this.subscriptions.push(
      this.sharedService.getMessagesBus().subscribe((response) => {
        if (response.type === 'NETWORK_CHANGE') {
          this.demands = [];
          this.getAllDemands();
          this.clearDataAndLoadReports(this.demandId);
        }
      })
    );
    this.sharedService.setPageTitle('QUALITY_AND_VIEWABILITY');
    this.getAllDemands();
  }

  clearDataAndLoadReports(_demandId: number) {
    this.initLoadedReportsData();
    this.currPage = 1;
    if (!_demandId) {
      _demandId = this.demandId;
    }
    this.getQualityByDemandReport(_demandId);
  }

  // Get the data for the grid-tabs
  getTabsData() {
    return [{ title: this.dictionaryService.get('BY_SUPPLY') }, { title: this.dictionaryService.get('BY_DOMAIN') }];
  }

  // Initialize loaded reports data
  initLoadedReportsData() {
    this.loadedReports = [];
    this.qualityService.pluginPartners.forEach((partner: any) => {
      this.loadedReports[partner.id] = [];
      this.getTabsData().forEach((tab: any, tabIndex: number) => {
        this.loadedReports[partner.id][tabIndex] = {
          data: false,
          totals: false,
        };
      });
    });
  }

  // Get columns
  getColumnsSettings() {
    switch (this.selectedTab) {
      case 0:
        return this.getSupplyColumns();
      case 1:
        return this.getDomainColumns();
      default:
        return [];
    }
  }

  // Get columns: demand-by-supply
  getSupplyColumns() {
    if (+this.currPluginPartner === 4) {
      return this.columnsSupplyMoat;
    }
  }

  // Get columns: demand-by-domain
  getDomainColumns() {
    if (+this.currPluginPartner === 4) {
      return this.columnsDomainMoat;
    }
  }

  getDemand() {
    const item: any = _.find(this.demands, { value: +this.demandId });
    let index = -1;
    if (item) {
      index = this.demands.indexOf(item);
      if (index !== -1) {
        return index;
      }
    }
    return index;
  }

  getAllDemands() {
    this.isLoading = true;
    this.subscriptions.push(
      this.httpService.post('vdsp_ws/getAllVastsBasic', this.reportParams).subscribe(
        (response) => {
          let data = response;
          data = _.sortBy(data, (o) => o.name);
          this.demands = [];
          for (let i = 0; i < data.length; i++) {
            this.demands.push({
              label: data[i].name,
              value: +data[i].vastId,
            });
          }
        },
        () => {
          // Display the error message
          this.isLoading = false;
          this.isError = true;
        }
      )
    );
  }

  getQualityByDemandReport(_demandId: number) {
    this.linkColumns = [];
    this.demandId = _demandId;
    const queryParams: any = {};
    if (!this.isLoading) {
      this.isLoading = true;
      this.reportParams = {
        quality_type: this.currPluginPartner,
        vastId: this.demandId,
        active: '1',
        startDate: moment(this.startDate).format('ddd MMM DD YYYY 00:00:00'),
        endDate: moment(this.endDate).format('ddd MMM DD YYYY 23:59:59'),
        filters: this.parseFilters(),
        sorting: this.sorting,
        page: this.currPage,
        amountPerPage: this.itemsPerPage,
        is_desktop: 0,
        is_mobile_web: 0,
        is_mobile_app: 0,
      };
      if (this.sorting.attrName) {
        if (_.find(this.getColumnsSettings(), { key: this.sorting.attrName })) {
          this.reportParams.sorting = this.sorting;
        } else {
          this.sorting = {};
        }
      }
      this.onEnvironmentFilterChange();
      queryParams.sd = moment(this.startDate).format('YYYY-MM-DD').toString();
      queryParams.ed = moment(this.endDate).format('YYYY-MM-DD').toString();
      queryParams.partner = this.currPluginPartner;
      queryParams.tab = this.selectedTab;
      this.router.navigate([`/quality/demand/${this.demandId}`], { queryParams: queryParams }).then(() => {
        return;
      });
      this.loadReport();
    }
  }

  initBySupplyData() {
    this.currSubscription = this.httpService
      .post('quality_report/getQualityReportVastByPlayer', this.reportParams)
      .subscribe(
        (response) => {
          const data = response.data.data;
          this.totalAmount = +response.data.paginator.totalAmount;
          this.numOfPages = +response.data.paginator.totalAmountOfPages;
          this.dataByDemandBySupply = data;
          this.onReportLoaded(0, 'data');
        },
        () => {
          this.onError();
        }
      );

    this.currTotalsSubscription = this.httpService
      .post('report_totals/getQualityReportByVastByPlayerTotals', this.reportParams)
      .subscribe(
        (response) => {
          this.dataByDemandBySupplyTotal = response.data[0];
          this.onReportLoaded(0, 'totals');
        },
        () => {
          this.onError();
        }
      );
    this.subscriptions.push(this.currSubscription);
    this.subscriptions.push(this.currTotalsSubscription);
  }

  initByDomainData() {
    this.currSubscription = this.httpService
      .post('quality_report/getQualityReportVastByDomain', this.reportParams)
      .subscribe(
        (response) => {
          const data = response.data.data;
          this.totalAmount = +response.data.paginator.totalAmount;
          this.numOfPages = +response.data.paginator.totalAmountOfPages;
          this.dataByDemandByDomain = data;
          this.onReportLoaded(1, 'data');
        },
        () => {
          this.onError();
        }
      );

    this.currTotalsSubscription = this.httpService
      .post('report_totals/getQualityReportByVastDomainTotals', this.reportParams)
      .subscribe(
        (response) => {
          this.dataByDemandByDomainTotal = response.data[0];
          this.onReportLoaded(1, 'totals');
        },
        () => {
          this.onError();
        }
      );
    this.subscriptions.push(this.currSubscription);
    this.subscriptions.push(this.currTotalsSubscription);
  }

  // On report loaded
  onReportLoaded(tab: number, type: string) {
    let currReportLoaded: any;
    let n: number;
    this.data = [];
    this.loadedReports[this.currPluginPartner][tab][type] = true;
    currReportLoaded = this.loadedReports[this.currPluginPartner][tab];
    if (currReportLoaded.data && currReportLoaded.totals) {
      // Dummy items for previous pages
      for (let i = 1; i < this.currPage; i++) {
        for (let j = 0; j < this.itemsPerPage; j++) {
          this.data.push({});
        }
      }
      switch (this.selectedTab) {
        case 0:
          this.data = this.data.concat(_.cloneDeep(this.dataByDemandBySupply));
          this.dataTotal = _.cloneDeep(this.dataByDemandBySupplyTotal);
          break;
        case 1:
          this.data = this.data.concat(_.cloneDeep(this.dataByDemandByDomain));
          this.dataTotal = _.cloneDeep(this.dataByDemandByDomainTotal);
          break;
      }
      // Dummy items for next pages
      for (let i: number = this.currPage; i < this.numOfPages; i++) {
        n = i + 1 < this.numOfPages ? this.itemsPerPage : this.totalAmount - (this.numOfPages - 1) * this.itemsPerPage;
        for (let j = 0; j < n; j++) {
          this.data.push({});
        }
      }
      this.isLoading = false;
      this.currSubscription = null;
      this.currTotalsSubscription = null;
    }
  }

  loadReport() {
    const currReportLoaded: any = this.loadedReports[this.currPluginPartner][this.selectedTab];
    if (!currReportLoaded.data || !currReportLoaded.totals) {
      this.isLoading = true;
      this.sharedService.sendMessage('GRID_DETECT_CHANGES');
      if (this.currSubscription) {
        this.currSubscription.unsubscribe();
      }
      if (this.currTotalsSubscription) {
        this.currTotalsSubscription.unsubscribe();
      }
      switch (this.selectedTab) {
        case 0:
          this.initBySupplyData();
          break;
        case 1:
          this.initByDomainData();
          break;
      }
    } else {
      this.onReportLoaded(this.selectedTab, 'data');
    }
  }

  onError() {
    this.isLoading = false;
    this.isError = true;
    this.currSubscription = null;
    this.currTotalsSubscription = null;
  }

  // Export all data
  exportAll() {
    let path = '';
    let reportParams: any;
    if (this.selectedTab === 0) {
      path = 'getQualityReportVastByPlayer';
    } else if (this.selectedTab === 1) {
      path = 'getQualityReportVastByDomain';
    } else {
      return;
    }
    this.isExporting = true;
    reportParams = _.cloneDeep(this.reportParams);
    delete reportParams.amountPerPage;
    this.subscriptions.push(
      this.httpService.post('reports_csv_export/' + path, reportParams).subscribe(
        (response: any) => {
          const blob = new Blob([response.data], { type: 'text/csv; charset=utf-8' });
          saveAs(blob, this.dictionaryService.get('EXPORTED_DATA') + '.csv');
          this.isExporting = false;
          this.sharedService.sendMessage('GRID_DETECT_CHANGES');
        },
        () => {
          this.isExporting = false;
          this.isError = true;
          this.sharedService.sendMessage('GRID_DETECT_CHANGES');
        }
      )
    );
  }

  // Parse filters
  parseFilters() {
    const filters: any = _.cloneDeep(this.filters);
    if (filters.player_type) {
      if (filters.player_type.length > 0) {
        filters.player_type = filters.player_type[0];
      }
    }
    if (filters.vast_type) {
      if (filters.vast_type.length > 0) {
        filters.vast_type = filters.vast_type[0];
      }
    }
    if (filters.revenue) {
      if (filters.revenue.hasOwnProperty('min') && filters.revenue.min !== null) {
        filters.revenue.min = parseFloat(filters.revenue.min.toString().replace(/[^0-9.]/g, ''));
      }
      if (filters.revenue.hasOwnProperty('max') && filters.revenue.max !== null) {
        filters.revenue.max = parseFloat(filters.revenue.max.toString().replace(/[^0-9.]/g, ''));
      }
    }
    delete filters.environment;
    return filters;
  }

  getDates() {
    const dates = {};
    dates['sd'] = moment(this.startDate).format('YYYY-MM-DD').toString();
    dates['ed'] = moment(this.endDate).format('YYYY-MM-DD').toString();
    return dates;
  }

  // On tab selected
  onTabSelected($event: any) {
    const queryParams: any = _.cloneDeep(this.queryParams);
    queryParams.tab = $event;
    this.router.navigate([], { queryParams: queryParams }).then(() => {
      return;
    });
  }

  //filter for environment
  onEnvironmentFilterChange() {
    switch (this.filters.environment) {
      case this.dictionaryService.get('DESKTOP'):
        this.reportParams.is_desktop = 1;
        this.reportParams.is_mobile_web = 0;
        this.reportParams.is_mobile_app = 0;
        break;
      case this.dictionaryService.get('MOBILE_WEB'):
        this.reportParams.is_desktop = 0;
        this.reportParams.is_mobile_web = 1;
        this.reportParams.is_mobile_app = 0;
        break;
      case this.dictionaryService.get('MOBILE_APP'):
        this.reportParams.is_desktop = 0;
        this.reportParams.is_mobile_web = 0;
        this.reportParams.is_mobile_app = 1;
        break;
    }
  }
  // On filter change
  onFilterChange($event: any) {
    this.filters = _.cloneDeep($event);
    this.initLoadedReportsData();
    this.clearDataAndLoadReports(this.demandId);
  }

  // On sort change
  onSortChange($event: any) {
    this.sorting = {
      attrName: $event.sortCell,
      sort: $event.sortDir,
    };
    this.initLoadedReportsData();
    this.clearDataAndLoadReports(this.demandId);
  }

  // On pagination
  onPagination($event: any) {
    this.initLoadedReportsData();
    this.currPage = $event;
    this.getQualityByDemandReport(this.demandId);
  }

  // Handle a 'start-date-changed' event from the datepicker component
  startDateChanged($event: any) {
    this.startDate = $event;
  }

  // Handle an 'end-date-changed' event from the datepicker component
  endDateChanged($event: any) {
    const queryParams: any = _.cloneDeep(this.queryParams);
    this.endDate = $event;
    if (this.endDate !== null) {
      this.initLoadedReportsData();
      this.currPage = 1;
      queryParams.sd = moment(this.startDate).format('YYYY-MM-DD').toString();
      queryParams.ed = moment(this.endDate).format('YYYY-MM-DD').toString();
      this.router.navigate([], { queryParams: queryParams }).then(() => {
        return;
      });
    }
  }
}
